import React, { useState } from 'react';
import { bookingPaymentService, formatCurrency } from '../../services/bookingPaymentService';
import './VoucherPayPalButton.css'; // Reuse existing button styles

interface BookingKlarnaButtonProps {
  bookingId: number;
  amount: number;
  onSuccess?: (result: { bookingId: number; amount: number }) => void;
  onError: (error: string) => void;
  onCancel?: () => void;
  disabled?: boolean;
}

/**
 * Klarna Button Component for Booking Payments
 *
 * This component handles the Klarna/Sofort payment flow for bookings:
 * 1. Creates a Klarna session via our backend (/api/payment/initiate)
 * 2. Redirects to Klarna for payment
 * 3. (Return page handles status verification)
 */
const BookingKlarnaButton: React.FC<BookingKlarnaButtonProps> = ({
  bookingId,
  amount,
  onSuccess,
  onError,
  onCancel,
  disabled = false,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleKlarnaClick = async () => {
    if (disabled || isLoading) return;

    setIsLoading(true);

    try {
      const baseUrl = window.location.origin;
      const returnUrl = `${baseUrl}/buchung/success?bookingId=${bookingId}&provider=klarna`;
      const cancelUrl = `${baseUrl}/checkout/${bookingId}?cancelled=true`;

      console.log('Initiating Klarna payment for booking:', bookingId);

      const result = await bookingPaymentService.initiateKlarnaPayment(
        bookingId,
        returnUrl,
        cancelUrl
      );

      console.log('Klarna initiation result:', result);

      if (result.success && result.paymentUrl) {
        // Redirect to Klarna
        window.location.href = result.paymentUrl;
      } else {
        onError(result.errorMessage || 'Konnte Klarna-Zahlung nicht starten');
        setIsLoading(false);
      }
    } catch (err: any) {
      console.error('Klarna payment error:', err);
      onError(err.message || 'Fehler beim Starten der Klarna-Zahlung');
      setIsLoading(false);
    }
  };

  return (
    <div className="voucher-paypal-button-container booking-klarna-button-container">
      <button
        className="voucher-paypal-button booking-klarna-button"
        onClick={handleKlarnaClick}
        disabled={isLoading || disabled}
        style={{ background: 'linear-gradient(135deg, #ffb3c7 0%, #ffa0b4 100%)' }}
      >
        {isLoading ? (
          <span className="paypal-loading">
            <span className="spinner"></span>
            Wird verarbeitet...
          </span>
        ) : (
          <>
            <span className="klarna-logo-text" style={{ fontWeight: 'bold', color: '#0a0b09', letterSpacing: '0.5px' }}>
              Sofort
            </span>
            <span className="paypal-amount" style={{ color: '#0a0b09' }}>{formatCurrency(amount)}</span>
          </>
        )}
      </button>
      <p className="paypal-secure-note">
        <span className="secure-icon">🔒</span>
        Sichere Sofort-Zahlung via Klarna
      </p>
    </div>
  );
};

export default BookingKlarnaButton;
